import { RouteLocationRaw } from "vue-router"
import { useAcl } from "vue-simple-acl"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  const isSuperAdminOnly = to.meta.superAdminOnly === true
  const hasAccess = isSuperAdminOnly
    ? useAcl().can("superAdmin")
    : useAcl().can.any(["admin", "superAdmin"])

  if (!hasAccess) {
    return next({
      name: "Error",
      query: {
        code: isSuperAdminOnly ? 404 : 403
      }
    })
  }
  next()
}
